<template>
  <div>
    <div class="main-content card p-1" v-if="loader === 100">
      <div class="row justify-content-center">
        <div class="col-md-12 mb-2">
          <button class="btn btn-primary" @click="clearAll()">
            Limpar todos os setores e locais
          </button>
        </div>
        <div class="col-md-12">
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col" style="width: 10%">#</th>
                <th scope="col" style="width: 30%">Nome do Usuário</th>
                <th scope="col" style="width: 20%">Setor</th>
                <th scope="col" style="width: 20%">Local</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, index) in users" :key="index">
                <th scope="row">{{ index + 1 }}</th>
                <td>{{ user.name }}</td>
                <td>
                  <v-select
                    :options="user.setores_disponiveis"
                    :reduce="(setores) => setores"
                    :label="'nome'"
                    v-model="user.setor_logado_obj"
                    class="vselect"
                    @input="
                      getLocaisDisponiveis(user, index),
                        saveSetorLocal(user, index)
                    "
                  ></v-select>
                </td>
                <td @click="getLocaisDisponiveis(user, index)">
                  <span v-if="user.locais_disponiveis">
                    <v-select
                      :options="user.locais_disponiveis"
                      :reduce="(locais) => locais.id"
                      :label="'nome'"
                      v-model="user.local_logado"
                      class="vselect"
                      @input="saveSetorLocal(user, index)"
                    ></v-select>
                  </span>
                  <span v-else-if="user.local_logado_obj" class="clickable">
                    <i class="mr-1">{{ user.local_logado_obj.nome }}</i>
                    <i class="fas fa-edit"></i>
                  </span>
                  <span class="clickable" v-else-if="user.setor_logado_obj"
                    >Clique para ver os locais disponíveis</span
                  >
                  <span class="clickable" v-else>Selecione um setor</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      loader: 0,
      users: [],
      setores: [],
    };
  },
  computed: {},
  methods: {
    clearAll() {
      const self = this;
      let api = self.$store.state.api + "user/clear-setor-local/";

      swal({
        title: "Deseja limpar os setores e locais?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, limpar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "A operação foi cancelada!", "info");
            break;

          case "confirm":
            axios
              .post(api)
              .then((response) => {
                swal(
                  "Sucesso",
                  "Setores e locais limpos com sucesso!",
                  "success",
                );

                self.getUsers();
              })
              .catch((error) => {
                self.$message(null, error.response.data, "error");
              });

            break;
        }
      });
    },
    limparSetorLocal: function (user, index) {
      const self = this;
      let api = self.$store.state.api + "user/save-setor-local/";

      let fd = {
        user_id: user.id,
        setor_logado: null,
        local_logado: null,
      };

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success",
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    saveSetorLocal: function (user, index) {
      const self = this;
      let api = self.$store.state.api + "user/save-setor-local/";

      let fd = {
        user_id: user.id,
        setor_logado: user.setor_logado_obj ? user.setor_logado_obj.id : null,
        local_logado: user.local_logado ? user.local_logado : null,
      };

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success",
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getSetores: function () {
      const self = this;
      const api =
        self.$store.state.api + "setores?ativo=1&paginated=false&with[]=locais";

      axios
        .get(api)
        .then((response) => {
          self.setores = response.data.data;
          self.setLoader(20);

          if (!self.$route.params.id) {
            self.setLoader(10);
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getLocaisDisponiveis(user, index) {
      const self = this;
      if (!user.setor_logado_obj) {
        return;
      }
      const api =
        self.$store.state.api +
        "locais-chamador/" +
        user.setor_logado_obj.id +
        "?local_id=" +
        (user.local_logado ? user.local_logado : "");

      axios
        .get(api)
        .then((response) => {
          self.users[index].locais_disponiveis = response.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsers: function () {
      const self = this;
      const api = self.$store.state.api + "users?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.users = response.data.data;

          if (self.loader < 100) {
            self.setLoader(60);
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;

    self.setLoader(10);
    self.getSetores();
    self.getUsers();
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped></style>
